/* The artwork viewer: a near-black void in both colour schemes, so the art reads the same
   whatever the page around it. */

/* MUI's Dialog paper and backdrop carry theme styles at the same specificity and are injected
   later, so these need !important to win (same approach as .map-recenter in GoogleMaps.css). */
.backdrop {
  background-color: var(--ih-scrim) !important;
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
}

.paper {
  margin: 0 !important;
  max-width: none !important;
  max-height: 100dvh !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  overflow: visible !important;
  overscroll-behavior: contain;
  color: #f4f2f0;
}

.close {
  position: fixed !important;
  top: 16px;
  right: 16px;
  z-index: 5;
  width: 44px;
  height: 44px;
  color: #f4f2f0 !important;
  background-color: rgba(244, 242, 240, 0.14) !important;
}

.close:hover {
  background-color: rgba(244, 242, 240, 0.24) !important;
}

.close:global(.Mui-focusVisible) {
  outline-color: #f4f2f0 !important;
}

.figure {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ih-space-md);
  padding: var(--ih-space-xxl) var(--ih-space-xxl) var(--ih-space-lg);
}

.stage {
  position: relative;
  display: grid;
}

/* Shown whole: never larger than the window, never cropped. */
.image {
  grid-area: 1 / 1;
  display: block;
  width: auto;
  height: auto;
  max-width: min(88vw, 1200px);
  max-height: calc(100dvh - 180px);
  object-fit: contain;
  border-radius: var(--ih-radius-md);
}

.overlay {
  grid-area: 1 / 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* The prev/next controls are <button>s; each takes half the frame so the tap targets cover
   the image edge to edge. The visible part is a 44px chip at the edge. */
.overlay > button {
  flex: 1 1 50%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #f4f2f0;
  touch-action: manipulation;
}

.back {
  justify-content: flex-start;
}

.forward {
  justify-content: flex-end;
}

.overlay > button:focus-visible {
  outline: none;
}

.overlay > button:focus-visible .chip {
  outline: 2px solid #f4f2f0;
  outline-offset: 2px;
}

.chip {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: rgba(12, 11, 11, 0.5);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  transition:
    background-color var(--ih-dur-fast) var(--ih-ease-out),
    transform var(--ih-dur-fast) var(--ih-ease-out);
}

.chip svg {
  font-size: 18px;
}

.overlay > button:hover .chip {
  background-color: rgba(12, 11, 11, 0.72);
}

.overlay > button:active .chip {
  transform: scale(0.92);
}

.texts {
  width: 100%;
  max-width: min(88vw, 640px);
  text-align: center;
}

.artist {
  color: #f4f2f0 !important;
  font-size: var(--ih-label-size);
  font-weight: 600;
  letter-spacing: var(--ih-label-tracking);
  text-decoration-color: rgba(244, 242, 240, 0.4) !important;
}

.texts p {
  margin: var(--ih-space-xxs) 0 0;
  font-size: var(--ih-callout-size);
  line-height: var(--ih-callout-leading);
  color: rgba(244, 242, 240, 0.72);
  overflow-wrap: anywhere;
}

/* fullScreen Dialog on phones: the paper is the void, the image fills the width. */
@media (max-width: 599.95px) {
  .paper {
    background-color: #080808 !important;
    justify-content: center;
  }

  .figure {
    padding: 72px 0 var(--ih-space-xl);
  }

  .image {
    width: 100vw;
    max-width: 100vw;
    max-height: calc(100dvh - 200px);
    border-radius: 0;
  }

  .texts {
    padding-inline: var(--ih-gutter);
  }
}
